const PER_FILE_MERGE_TYPES = ['PDF_PER_FILE', 'ARCHIVE_PER_FILE', 'VIDEO_PER_FILE', 'ANIMATED_PER_FILE'];

export function isPerFileMergeType(mergeType: string | undefined): boolean {
    return PER_FILE_MERGE_TYPES.includes(mergeType);
}
